<app-dialog [title]="data.title" (close)="close()">
    <ng-container dialogHeader>
        <ng-container [ngTemplateOutlet]="panelTools"></ng-container>
    </ng-container>
    <ng-container dialogContent>
        <div #formRef [formGroup]="form" class="flex flex-col gap-2 mr-2">
            <ng-container *ngIf="isLoaded">
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_main_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto grid grid-cols-2 gap-4">
                    <div class="max-h-60">
                        <fui-image-picker
                            [editable]="(disableProfileFields$ | async) === false"
                            [label]="dictionary.users_field_photos"
                            [imageUrl]="photoUrl"
                            [useCrop]="true"
                            [cropperOptions]="cropperOptions"
                            [maxSize]="10"
                            [actions]="photoActions"
                            (uploaded)="fileUploaded($event)"
                            (failed)="fileFailed($event)"
                            (removed)="fileRemoved()"
                            class="mb-4"
                        >
                            <span class="file-zone-text-container">
                                <mat-icon fontSet="mdi" fontIcon="mdi-format-vertical-align-top"></mat-icon>
                                <span class="file-zone-text">
                                    <span class="file-zone-text-header">{{
                                        appService.language_dictionary.files_download_files
                                    }}</span>
                                    <span class="file-zone-text-sub-header">
                                        {{ appService.language_dictionary.files_drag_or }}
                                        <span class="file-zone-text-link">
                                            {{ appService.language_dictionary.files_choose }}
                                        </span>
                                    </span>
                                </span>
                            </span>
                            <span class="file-zone-text-warning">
                                {{ appService.language_dictionary.files_valid_formats }} jpg, png.
                            </span>
                            <br />
                            <span class="file-zone-text-warning">
                                {{ appService.language_dictionary.help_max_file_size }}
                                : 10 {{ appService.language_dictionary.files_mb }}
                            </span>
                        </fui-image-picker>
                    </div>
                    <div class="flex flex-col gap-2">
                        <fui-text-input
                            [fieldGroup]="form"
                            [fieldName]="'lastname'"
                            [label]="dictionary.user_surname"
                            [forceDisabled]="disableProfileFields$ | async"
                            [validationErrorService]="validationErrorService"
                            [maxLength]="255"
                            class="flex-none block"
                        ></fui-text-input>
                        <fui-text-input
                            [fieldGroup]="form"
                            [fieldName]="'firstname'"
                            [label]="dictionary.user_name"
                            [forceDisabled]="disableProfileFields$ | async"
                            [validationErrorService]="validationErrorService"
                            [maxLength]="255"
                            class="flex-none block"
                        ></fui-text-input>
                        <fui-text-input
                            [fieldGroup]="form"
                            [fieldName]="'middlename'"
                            [label]="dictionary.user_patronymic"
                            [forceDisabled]="disableProfileFields$ | async"
                            [validationErrorService]="validationErrorService"
                            [maxLength]="255"
                            class="flex-none block"
                        ></fui-text-input>
                        <fui-select
                            [fieldGroup]="form"
                            [fieldName]="'roles'"
                            [label]="dictionary.system_role_name"
                            [itemService]="defaultStringNameItemService"
                            [items]="data.guides.roles ? data.guides.roles : []"
                            [forceDisabled]="disableNonProfileFields$ | async"
                            [multiple]="true"
                            [validationErrorService]="validationErrorService"
                            class="flex-none block"
                        ></fui-select>
                    </div>
                </div>
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_position_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto grid grid-cols-2 gap-x-4 gap-y-2">
                    <fui-select
                        [fieldGroup]="form"
                        [fieldName]="'position'"
                        [label]="dictionary.factor_position"
                        [itemService]="defaultStringNameItemService"
                        [items]="positionsList$ | async"
                        [loading]="positionsListLoading$ | async"
                        [forceDisabled]="disableNonProfileFields$ | async"
                        [multiple]="true"
                        [validationErrorService]="validationErrorService"
                        [showAddButton]="accessCatalogs?.add === 1"
                        (addButtonClicked)="addNewPosition()"
                    ></fui-select>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'company'"
                        [label]="dictionary.user_organization"
                        [forceDisabled]="disableNonProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                    <div>
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.assigned_to_the_subject,
                                inputType: 'text',
                                name: 'subject_id',
                                required: true,
                                treeParentId: 1,
                                addTreeHyphen: true,
                                multiple: true,
                                options: data.guides.subjects ? data.guides.subjects : [],
                                disabled: disableNonProfileFields$ | async,
                                validations: [
                                    {
                                        name: 'required',
                                        message: appService.language_dictionary.system_field_required,
                                    },
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form"
                        ></ng-container>
                    </div>
                    <fui-checkbox
                        [fieldGroup]="form"
                        [fieldName]="'access_child'"
                        [label]="dictionary.user_subsidiaries_are_available"
                        [forceDisabled]="disableNonProfileFields$ | async"
                    ></fui-checkbox>
                    <fui-select
                        [fieldGroup]="form"
                        [fieldName]="'chief'"
                        [label]="dictionary.user_head"
                        [itemService]="userListItemService"
                        [items]="data.guides.users"
                        [forceDisabled]="disableNonProfileFields$ | async"
                    ></fui-select>
                </div>
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_account_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto grid grid-cols-2 gap-x-4 gap-y-2">
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'login'"
                        [label]="dictionary.system_login"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'ip'"
                        [label]="dictionary.user_ip_access_addresses"
                        [forceDisabled]="disableNonProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="512"
                    ></fui-text-input>
                    <div>
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.system_password,
                                inputType: 'password',
                                name: 'password',
                                required: !data.id,
                                autoComplete: 'new-password',
                                disabled: disableProfileFields$ | async,
                                validations: [
                                    {
                                        name: 'required',
                                        message: appService.language_dictionary.system_field_required,
                                    },
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form.get('passwordGroup')"
                        ></ng-container>
                        <mat-error
                            *ngIf="
                                form.get('passwordGroup').hasError('childrenNotEqual') &&
                                form.get('passwordGroup').get('repeat_password').value
                            "
                        >
                        </mat-error>
                        <div
                            class="password-validation-block form-field-margin-bottom"
                            *ngIf="form.get('passwordGroup').get('password').value"
                        >
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('hasLatinCharacters')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasLatinCharacters')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_latin_characters }}</span>
                            </div>
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('minlength')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_least_characters }}</span>
                            </div>
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('hasNumber')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasNumber')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_contain_number }}</span>
                            </div>
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('hasCapitalCase')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasCapitalCase')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_contain_capital_case }}</span>
                            </div>
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('hasSmallCase')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasSmallCase')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_contain_letter_case }}</span>
                            </div>
                            <div
                                *ngIf="validationPass !== '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('hasSpecialCharacters')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('hasSpecialCharacters')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_contain_special_character }}</span>
                            </div>
                            <div
                                *ngIf="validationPass === '0'"
                                [ngClass]="
                                    form.get('passwordGroup').get('password').hasError('required') ||
                                    form.get('passwordGroup').get('password').hasError('minlength')
                                        ? 'text-danger'
                                        : 'text-success'
                                "
                            >
                                <mat-icon
                                    fontSet="mdi"
                                    [fontIcon]="
                                        'mdi-' +
                                        (form.get('passwordGroup').get('password').hasError('required') ||
                                        form.get('passwordGroup').get('password').hasError('minlength')
                                            ? 'close-circle'
                                            : 'check-circle')
                                    "
                                ></mat-icon>
                                <span>{{ appService.language_dictionary.users_must_least_characters_3 }}</span>
                            </div>
                            <div
                                *ngIf="
                                    form.get('passwordGroup').hasError('childrenNotEqual') &&
                                    form.get('passwordGroup').get('repeat_password').value
                                "
                                class="text-danger password-validation-block"
                            >
                                <mat-icon fontSet="mdi" fontIcon="mdi-close-circle"></mat-icon>
                                <span> {{ appService.language_dictionary.user_pass_you_entered_not_match }}</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.user_confirm_pass,
                                inputType: 'password',
                                name: 'repeat_password',
                                required: !data.id,
                                disabled: disableProfileFields$ | async,
                                validations: [
                                    {
                                        name: 'required',
                                        message: appService.language_dictionary.system_field_required,
                                    },
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form.get('passwordGroup')"
                        ></ng-container>
                    </div>
                </div>
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_locked_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto">
                    <fui-checkbox
                        [fieldGroup]="form"
                        [fieldName]="'active'"
                        [label]="dictionary.user_active"
                        [forceDisabled]="disableNonProfileFields$ | async"
                    ></fui-checkbox>
                    <div class="user_locked_text">{{ appService.language_dictionary.users_locked_interval }}:</div>
                    <div class="flex-auto grid grid-cols-2 gap-x-4 gap-y-2">
                        <div>
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'date',
                                    disabled: disableNonProfileFields$ | async,
                                    label: appService.language_dictionary.beginning_with,
                                    name: 'date_start_deactivation',
                                }"
                                [group]="form"
                                [data]="{ maxField: 'date_end_deactivation' }"
                            >
                            </ng-container>
                        </div>
                        <div>
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'date',
                                    disabled: disableNonProfileFields$ | async,
                                    label: appService.language_dictionary.finishing_by,
                                    name: 'date_end_deactivation',
                                }"
                                [group]="form"
                                [data]="{ minField: 'date_start_deactivation' }"
                            >
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_personal_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto grid grid-cols-4 gap-x-4 gap-y-2">
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'snils'"
                        [label]="dictionary.snils"
                        [forceDisabled]="disableProfileFields$ | async"
                        [mask]="'9{3}-9{3}-9{3} 9{2}'"
                    ></fui-text-input>
                    <div>
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'date',
                                label: appService.language_dictionary.date_of_birth,
                                disabled: disableProfileFields$ | async,
                                name: 'date_birth',
                            }"
                            [group]="form"
                            [data]="{ maxDate: now }"
                        >
                        </ng-container>
                    </div>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'personal_phone'"
                        [label]="dictionary.users_personal_phone_number"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="50"
                    ></fui-text-input>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'personal_email'"
                        [label]="dictionary.users_personal_email"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                </div>
                <div class="flex-none">
                    <div class="text-lg">{{ appService.language_dictionary.users_contact_information }}</div>
                    <mat-divider></mat-divider>
                </div>
                <div class="flex-auto grid grid-cols-3 gap-x-4 gap-y-2">
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'phone'"
                        [label]="dictionary.users_work_phone_number"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="128"
                    ></fui-text-input>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'email'"
                        [label]="dictionary.users_work_email"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'fax'"
                        [label]="dictionary.user_fax"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                </div>
                <div class="flex-auto grid grid-cols-2 gap-x-4 gap-y-2">
                    <fui-text-input
                        [fieldGroup]="form"
                        [fieldName]="'address'"
                        [label]="dictionary.import_address_title"
                        [forceDisabled]="disableProfileFields$ | async"
                        [validationErrorService]="validationErrorService"
                        [maxLength]="255"
                    ></fui-text-input>
                    <fui-select
                        [fieldGroup]="form"
                        [fieldName]="'menu_id'"
                        [label]="dictionary.personal_start_page_title"
                        [itemService]="defaultStringNameItemService"
                        [items]="(menuListLoader.data$ | async) ?? []"
                        [loading]="menuListLoader.loading$ | async"
                        [forceDisabled]="disableProfileFields$ | async"
                    ></fui-select>
                    <fui-text-area
                        [fieldGroup]="form"
                        [fieldName]="'comments'"
                        [label]="dictionary.user_note"
                        [forceDisabled]="disableProfileFields$ | async"
                    ></fui-text-area>
                    <fui-text-area
                        [fieldGroup]="form"
                        [fieldName]="'contacts'"
                        [label]="dictionary.contact_information"
                        [forceDisabled]="disableProfileFields$ | async"
                    ></fui-text-area>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            *ngIf="(disableProfileFields$ | async) === false"
            (clickEvent)="save()"
            [label]="appService.language_dictionary.system_save"
            [icon]="'content-save'"
            [height]="'mini'"
        >
        </fui-button>
        <fui-button
            *ngIf="
                !appService.settings?.ext_esia.length &&
                (appService.settings?.member_login?.value === 'by_esia' ||
                    appService.settings?.member_login?.value === 'together_esia')
            "
            (clickEvent)="authByEsia()"
            [label]="appService.language_dictionary.user_esia"
            [height]="'mini'"
            [color]="'light'"
            [disabled]="
                this.appService?.settings.registration_by_esia.value !== 'without_esia' ||
                this.appService?.userData.is_esia
            "
        >
        </fui-button>
        <fui-button
            (clickEvent)="close()"
            [label]="appService.language_dictionary.system_cancel"
            [height]="'mini'"
            [color]="'light'"
            [icon]="'close'"
        >
        </fui-button>
    </ng-container>
</app-dialog>

<ng-template #panelTools>
    <panel-tools [showRequiredLabel]="true" [isPanelToolsDialog]="true" [showCloseButton]="false"> </panel-tools>
</ng-template>
